import { render, staticRenderFns } from "./LeilaoDataItem.vue?vue&type=template&id=57fba13c&"
import script from "./LeilaoDataItem.vue?vue&type=script&lang=js&"
export * from "./LeilaoDataItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports